import React from "react";
import styled from "styled-components";

const TextArea = (props) => {
	const showLabel = (e) => {
		if (e.target.value) e.target.parentElement.classList.add("value");
		else e.target.parentElement.classList.remove("value");
	};
	return (
		<ReactTextArea className={props.names}>
			<div className="field">
				<Wrapper className={`input_w ${props.defaultValue ? "value" : ""}`}>
					<textarea
						name={props.names}
						rows={props.rows}
						defaultValue={props.defaultValues}
						onChange={(e) => showLabel(e)}
						required={props.requireds}
					></textarea>
					<span>{props.labels}</span>
				</Wrapper>
				{props.helpText && <p className="help_note">{props.helpText}</p>}
			</div>
		</ReactTextArea>
	);
};

export default TextArea;

const Wrapper = styled.div`
	position: relative;
	position: relative;
	margin-top: 25px;

	textarea {
		border: 0;
		border: 1px solid #d8d8d8;
		border-radius: 5px;
		font-size: inherit;
		outline: none;
		width: 100%;
		padding: 15px 10px;
		font-family: var(--Montserat) !important;
		font-size: 15px;
	}

	span {
		position: absolute;
		top: 0px;
		left: 15px;
		transition: all 0.3s ease;
		pointer-events: none;
		font-size: 16px;
		color: var(--Gunmetal);
	}
	textarea:focus + span,
	&.value span {
		background: #ffffff;
		top: -10px;
		height: 20px;
		padding: 5px;
		margin: 0;
		color: #00838f;
		font-size: 14px;
		pointer-events: initial;
		left: 15px;
		line-height: 10px;
	}
	/* textarea:focus + span{
        padding: 5px !important;
        top: 10px;
    } */
`;

const ReactTextArea = styled.div`
	.help_note {
		font-size: 1em;
	}
`;
